/**
 * Fill the placeholder div for product price with data from WooCommerce
 *
 * @param {string} productId
 * @param {Object} product
 */
export const setProductPriceContent = ( productId, product ) => {
	const price = product?.price ?? false;
	const priceElement = document.getElementById(
		`ma-js-price-${ productId }`
	);

	if ( ! priceElement ) {
		console.warn( 'Found no dom element to insert the product price' );
		return;
	}

	if ( priceElement.classList.contains( 'ma-price-fetched' ) ) {
		return;
	}

	if ( price ) {
		const divElement = document.createElement( 'div' );
		divElement.className = 'ma-product-price-price';
		divElement.innerHTML = price;

		priceElement.classList.add( 'ma-price-fetched' );

		priceElement.appendChild( divElement );
	}

	priceElement.classList.remove( 'ma-line-loader' );
};
